import {
  APPLICATION_ID,
  AUTH_BACKEND_URL,
  BACKEND_URL,
  ENV_MIXPANEL_PROJECT_KEY,
  ENV_ZEPTO_DOMAIN,
  PARENT_APPLICATION_ID,
  PUBLIC_ASSETS_URL,
  REACT_APP_VENDOR_PORTAL_URL,
  S3_ASSETS_URL,
} from './environment';

export const CDNBaseURL = process.env[PUBLIC_ASSETS_URL] ?? '';
export const S3AssetUrl = process.env[S3_ASSETS_URL] ?? '';
export const BaseURL = process.env[BACKEND_URL];
export const AuthBaseURL = process.env[AUTH_BACKEND_URL];
export const ZEPTO_DOMAIN = process.env[ENV_ZEPTO_DOMAIN];
export const ApplicationId = process.env[APPLICATION_ID];
export const ParentApplicationId = process.env[PARENT_APPLICATION_ID];
export const MIXPANEL_PROJECT_KEY =
  process.env?.[ENV_MIXPANEL_PROJECT_KEY] ?? '';
export const VENDOR_PORTAL_URL =
  process.env?.[REACT_APP_VENDOR_PORTAL_URL] ?? '';

export const TOAST_AUTO_HIDE_DURATION = 2000;

export const ROWS_PER_PAGE = 50;

export const DeclarationConstants: Record<string, string> = {
  SELLER_PORTAL_LOGIN_TITLE: 'Login to Seller Portal',
  SELLER_PORTAL_LOGIN_MESSAGE: 'Please enter your credentials to continue.',
  FORGOT_PASSWORD_QUESTION: 'Forgot Password?',
  RESET_PASSWORD_TITLE: 'Reset Password',
  RESET_PASSWORD_MESSAGE: 'Enter your Email ID to reset your password.',
  PASSOWRD_RESET_LINK_SENT_TITLE: 'Password Reset Link sent',
  PASSOWRD_RESET_LINK_SENT_MESSAGE:
    'We have sent a link to your email to reset password.',
  LINK_EXPIRED_TITLE: 'Link Invalid / Expired',
  LINK_EXPIRED_MESSAGE: 'Please contact your Category Manager',
  LOADING_TITLE: 'Loading',
  LOADING_MESSAGE: 'Please Wait...',
  ERROR_TITLE: 'Something went wrong!',
  ERROR_MESSAGE: 'Please refresh the page',
  NO_RESPONSE_ERROR_MESSAGE: 'No Response',
  ACCOUNT_VERIFIED_MESSAGE: 'Please wait...',
  RESET_PASSWORD_SUCCESS_TITLE: 'Password reset successful!',
  RESET_PASSWORD_SUCCESS_MESSAGE: 'Please wait...',
  PASSWORD_HELPER_TEXT:
    'The password must be 8 to 32 characters long and must contain atleast one alphabet and one digit.',
  REMEMBER_PASSWORD_QUESTION: 'Remember Password?',
  CREATE_NEW_PASSWORD_TITLE: 'Create a New Password',
  CREATE_NEW_PASSWORD_MESSAGE: 'Enter the new password',
  PASSWORD_MISMATCH_MESSAGE: 'Passwords do not match!!',
  WELCOME_MESSAGE: 'Welcome to Seller Portal',
  DAILY_CAMPAIGNS: 'Daily Campaign Suggestions',
  YEARLY_CAMPAIGNS: 'Yearly Campaign Suggestions',
  COUPONS: 'Coupon Suggestions',
  RECEIVABLES: 'Receivables Suggestions',
  SEGMENT: 'Segments',
  SKU: 'SKUs',
  EXPERIMENTS: 'Experiments',
  REPORTS: 'Reports',
  ASN: 'ASN',
  PO: 'PO',
  PO_SUMMARY: 'PO Summary',
  BULK_PO_CREATION: 'Bulk PO Creation',
  VENDOR_NAME: 'Vendor Name',
  PO_VALUE: 'PO Value',
  QUANTITY: 'Qty',
  DESTINATION_STORE: 'Destination Store',
  PO_CREATED_ON: 'PO Created on',
  PO_EXPIRY_DATE: 'PO Expiry date',
  COMMENTS: 'Comments',
  UNKNOWN_ERROR_MESSAGE: 'Something Went Wrong!!',
  CONTACT_CATEGORY_MANAGER_MESSAGE:
    'In case of issues, please contact your Category Manager',
  CLEAR_ALL: 'Clear All',
  APPLY: 'Apply',
  TOOLTIP_DESCRIPTION:
    'All suggestions are based on zepto’s propriety algorithms to boost your business',
  PRICING_SUMMARY: 'Pricing',
  MARGIN: 'MARGIN',
  BAD_REQUEST_ERROR_MESSAGE: 'Bad Request',
  BULK_APPROVE: 'Bulk Approve',
  APPROVE: 'Approve',
  REJECT: 'Reject',
  PO_APPROVALS: 'PO Approvals',
  SUMMARY: 'Summary',
  CREATE_ASNS: 'Create ASNs',
  DOWNLOAD_ASN_FILE: 'Download ASN file',
  CREATE_ASN: 'Create ASN',
  REPORT: 'Report',
  ASN_CREATION_SUCCESS_MESSAGE: 'ASN Created Successfully!',
  ASN_CREATION_FAILURE_MESSAGE: 'Failed to create ASN!!',
  REFRESH: 'Refresh',
  UPLOAD: 'Upload',
  CREATE_PURCHASE_ORDER: 'Create Purchase Order',
  CREATE_PO: 'Create PO',
  RETRY_UPLOAD: 'Retry Upload',
  UPLOAD_FAILED: 'Upload Failed',
  PO_CANCELLED_SUCCESS_MESSAGE: 'Purchase Order Cancelled Successfully!',
  CANCEL_PO: 'Cancel PO',
  UPLOAD_PRICES: 'Upload Prices',
  UPLOAD_PRICES_ALERT: 'These prices will override the existing live prices',
  UPLOAD_PRICES_SUCCESS_MESSAGE: 'Sucessfully uploaded prices!',
  UPLOAD_PRICES_FAILURE_MESSAGE: 'Failed to upload prices!!',
  UPLOAD_SKU_PRICE: 'Upload SKU Price',
  CONFIRM: 'Confirm',
  DOWNLOAD_RPEORT: 'Download Report',
  DOWNLOAD: 'Download',
  DOWNLOAD_PO: 'Download PO',
  EDIT: 'Edit',
  VIEW: 'View',
  CANCEL_ASN: 'Cancel ASN',
  CREATE_PDF: 'Create PDF',
  EDIT_PO: 'Edit PO',
  SUBMIT: 'Submit',
  PO_UPDATED_SUCCESSFULLY: 'PO Updated Successfully!',
  CONTINUE: 'Continue',
  ASN_CANCEL_WARN_MESSAGE: 'Are you sure you want to cancel this ASN?',
  PO_CANCEL_WARN_MESSAGE: 'Are you sure you want to cancel this PO?',
  BULK_PO_PDF: 'Bulk PO PDF',
  DOWNLOADING_ACTION_TEXT: 'Downloading...',
  ASN_CANCELLED_SUCCESSFULLY: 'ASN Cancelled Successfully!!',
  BULK_UPLOAD: 'Bulk Upload',
  CREATE_BULK_JOBS: 'Create Bulk Jobs',
  BULK_JOBS: 'Bulk Jobs',
  BULK: 'Bulk',
  VIEW_BULK_JOBS_SUMMARY: 'View Bulk Jobs Summary',
  JOB_CREATE_SUCCESS_MESSAGE:
    'Your Bulk Job has been created and your Batch ID is',
  CREATE_BULK_ASN: 'Create Bulk ASN',
  BULK_REPORTS: 'Bulk Reports',
  CONFIRM_ASN: 'Confirm ASN',
  Exceptional_ASN_Handling: 'Exceptional ASN Handling',
  DOWNLOAD_ERROR_REPORT: 'Download Error Report',
  GO_TO_CONFIRM_ASN: 'Go to Confim ASN',
  ASN_CONFIRMED_SUCCESSFULLY: 'ASN Confimed Successfully!!',
  CANCEL: 'Cancel',
  ASN_CREATION_MESSAGE:
    'Your file has been processed. Please download the report for details of success and failure statuses.',
  ASN_CREATION_SUBTITLE:
    'Please add the invoice details against each ASN to confirm the ASN and get a thor ID. ',
  NOT_FOUND_MESSAGE: 'Looks like you have lost your way',
  GO_HOME: 'Go Home',
  LAST_UPDATED: 'Last updated on',
  CONFIRM_BULK_ASN: 'Confirm Bulk ASN',
  VIEW_SUMMARY: 'View Summary',
  ASN_CONFIRMATION_REQUESTED: 'ASN confirmation has been requested.',
  EXCEPTIONAL_ASN_WARN_MESSAGE: 'Are you sure you want to discard this ASN?',
  ASN_DISCARDED_SUCCESSFULLY: 'ASN Discarded Successfully!!',
  EDIT_DRAFT: 'Edit Draft',
  DISCARD_DRAFT: 'Discard Draft',
  ASN_CREATED_SUCCESSFULLY: 'ASN Created Successfully!!',
  PO_SUGGESTIONS: 'PO Suggestions',
  RETURN_PO_ACKNOWLEDGEMENT: 'Return PO Acknowledgement',
};

export const RegexConstants: Record<string, RegExp> = {
  otp: new RegExp(/^\d{6}$/),
  email: new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),
  password: new RegExp(/^(?=.*[0-9])(?=.*[a-zA-Z]).{8,32}$/),
  contact: new RegExp(/^[6-9]\d{9}$/),
  name: new RegExp(/^[a-zA-Z ]*$/),
  positiveNumberWithDecimal: new RegExp(
    /^[+]?([0-9]+(?:[.][0-9]*)?|\.[0-9]+)$/
  ),
  url: new RegExp(
    /^[-a-zA-Z0-9@:%._+~#=/]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/
  ),
  ifscCode: new RegExp(/^[A-Z]{4}0[A-Z0-9]{6}$/),
  onlyDigits: new RegExp(/^[0-9]+$/),
  universalStringValidity: new RegExp(/^[a-zA-Z0-9./,()@#&_\-+\n :]*$/),
  fssai: new RegExp(/^[0-9]{14}$/),
};

export const DEFAULT_APP_ENVIRONMENT = 'development';

export const SUCESS_SCREEN_DURATION = 2000;
export const OTPTimerCountdown = 60;
export const DEFAULT_OFFSET = 0;
export const DEFAULT_PAGE_INDEX = 0;

//default date ranges
const startDate = new Date();
const endDate = new Date();
startDate.setDate(startDate.getDate() - 30);
export const DEFAULT_START_DATE = startDate.toISOString();
export const DEFAULT_END_DATE = endDate.toISOString();

const startDateOneYear = new Date();
startDateOneYear.setFullYear(startDateOneYear.getFullYear() - 1);
export const DEFAULT_START_DATE_ONE_YEAR = startDateOneYear.toISOString();

export const MimeTypes = {
  SPREADSHEET:
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV: 'text/csv',
  PDF: 'application/pdf',
};
